import React, { useEffect, useState } from "react";
import "../assets/css/leaderboard.css";
import axios from "axios";
import { adminBaseURL } from "../config";
import diamondIcon from "../assets/image/diamond 2.png";
import leaderboardBg from "../assets/image/leaderboard bg.png";
import firstRankImg from "../assets/image/first rank 2.png";
import secondRankImg from "../assets/image/second_rank.png";
import thirdRankImg from "../assets/image/third_rank.png";

const Leaderboard = (props) => {
  const { dialog, setDialog } = props;
  const [leaderboardData, setLeaderboardData] = useState([]);

  useEffect(() => {
    if (dialog) {
      axios
        .get("/api/leaderboard")
        .then((res) => {
          if (res.data && res.data.ok) {
            setLeaderboardData((res.data.data || []).slice(0, 20));
          }
        })
        .catch((err) => console.log(err));
    }
  }, [dialog]);

  const handleClose = () => {
    setDialog(false);
  };

  const top3 = leaderboardData.slice(0, 3);
  const rest = leaderboardData.slice(3);

  // Fill empty spots for top 3 if necessary
  const first = top3[0] || null;
  const second = top3[1] || null;
  const third = top3[2] || null;

  const getProfileImage = (url, name) => {
    if (!url) return `https://ui-avatars.com/api/?name=${name || 'User'}&background=random`;
    if (url.startsWith("storage/")) {
      return adminBaseURL + url;
    }
    return url;
  };

  if (!dialog) return null;

  return (
    <div className="bottom-sheet-overlay" onClick={handleClose}>
      <div
        className="bottom-sheet-paper"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "#0b021a",
          display: "flex",
          flexDirection: "column",
          padding: 0,
          overflow: "hidden"
        }}
      >
        {/* Modal Header */}
        <div className="history-modal-header">
          <div style={{ width: "36px" }} />
          <h2 className="history-modal-title">Leaderboard</h2>
          <button className="history-modal-close" onClick={handleClose}>
            ✕
          </button>
        </div>

        {/* Modal Content */}
        <div className="leaderboard-content" style={{ backgroundImage: `url("${leaderboardBg}")` }}>

          {/* Podium Area */}
          <div className="podium-container">
            {/* 2nd Place */}
            <div className="podium-spot second-place">
              {second ? (
                <>
                  <div className="avatar-container">
                    <img className="rank-img rank-2" src={secondRankImg} alt="Rank 2" />
                    <img className="lb-avatar" src={getProfileImage(second.image, second.name)} alt={second.name} />
                  </div>
                  <div className="name-badge">{second.name}</div>
                  <div className="podium-user-id">ID: {second.uniqueId}</div>
                  <div className="lb-diamond">
                    <img src={diamondIcon} alt="diamond" />
                    <span>{second.totalWinCoin}</span>
                  </div>
                </>
              ) : <div className="empty-spot" />}
            </div>

            {/* 1st Place */}
            <div className="podium-spot first-place">
              {first ? (
                <>
                  <div className="first-rank-wrapper">
                    <img className="first-rank-frame" src={firstRankImg} alt="Rank 1" />
                    <img className="first-rank-avatar" src={getProfileImage(first.image, first.name)} alt={first.name} />
                    <div className="first-rank-name">{first.name}</div>
                  </div>
                  <div className="podium-user-id">ID: {first.uniqueId}</div>
                  <div className="lb-diamond">
                    <img src={diamondIcon} alt="diamond" />
                    <span>{first.totalWinCoin}</span>
                  </div>
                </>
              ) : <div className="empty-spot" />}
            </div>

            {/* 3rd Place */}
            <div className="podium-spot third-place">
              {third ? (
                <>
                  <div className="avatar-container">
                    <img className="rank-img rank-3" src={thirdRankImg} alt="Rank 3" />
                    <img className="lb-avatar" src={getProfileImage(third.image, third.name)} alt={third.name} />
                  </div>
                  <div className="name-badge">{third.name}</div>
                  <div className="podium-user-id">ID: {third.uniqueId}</div>
                  <div className="lb-diamond">
                    <img src={diamondIcon} alt="diamond" />
                    <span>{third.totalWinCoin}</span>
                  </div>
                </>
              ) : <div className="empty-spot" />}
            </div>
          </div>

          {/* List Area */}
          <div className="lb-list-container">
            {rest.map((user, index) => (
              <div className="lb-list-item" key={user.userId || index}>
                <div className="lb-list-rank">{index + 4}</div>
                <img className="lb-list-avatar" src={getProfileImage(user.image, user.name)} alt={user.name} />
                <div className="lb-list-info">
                  <div className="lb-list-name">{user.name}</div>
                  <div className="lb-list-id">Id:- {user.uniqueId}</div>
                </div>
                <div className="lb-list-score">
                  <img src={diamondIcon} alt="diamond" />
                  <span>{user.totalWinCoin}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
